const culturalCompetenceValues = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' }
];

export default culturalCompetenceValues;
